export interface AliveAIFeature {
  title: string;
  route: string;
  description: string;
  prompts?: string[];
  promptIds?: string[];
  heroTitle: string;
  heroSubtitle: string;
  metaDescription: string;
  keywords: string[];
  benefits: string[];
  features: {
    title: string;
    description: string;
    icon?: string;
  }[];
  callToAction: string;
  faq?: {
    question: string;
    answer: string;
  }[];
}

export const ALIVEAI_FEATURES: AliveAIFeature[] = [
  {
    title: 'Realistic AI Porn Generator',
    route: '/generate/realistic-ai',
    description:
      'Generate ultra-realistic AI images with advanced photorealistic capabilities',
    heroTitle: 'Create Hyper-Realistic AI Porn',
    heroSubtitle:
      'Advanced photorealistic AI generator with unmatched quality and detail',
    metaDescription:
      'Generate ultra-realistic AI nude images with our advanced AI generator. Create lifelike portraits, scenes, and characters with incredible detail.',
    keywords: [
      'realistic AI generator',
      'photorealistic AI',
      'lifelike AI images',
      'realistic AI porn',
    ],
    prompts: [
      'Two sisters from america, posing sexy on the bed',
      'Busty brunette in a sexy outfit, exposing her breasts',
      'Nude instagram woman standing naked, oily / shiny skin',
      'PAWG girl lying in bed with pink thong and exposed butt',
    ],
    promptIds: [
      '70799f2b-96eb-4da1-8549-a3190fc10e3f',
      '4ba2e7cd-3625-40bb-948a-d3d545286402',
      '1cea3d3b-bc74-4179-aa71-f2cb3aaf6abf',
      'b980e922-8918-4b07-9303-9d5aa39e52f7',
    ],
    benefits: [
      'Industry-leading photorealistic quality',
      'Advanced lighting and texture rendering',
      'Natural skin tones and facial features',
      'Fully supporting nude, porn and erotic content',
    ],
    features: [
      {
        title: 'Advanced Realism Engine',
        description:
          'Our cutting-edge AI model produces images indistinguishable from real photographs',
        icon: 'auto_awesome',
      },
      {
        title: 'Porn understanding',
        description:
          'Sophisticated understanding of adult NSFW content with complex poses and expressions',
        icon: 'accessibility_new',
      },
      {
        title: 'Texture Perfection',
        description:
          'Incredible detail in skin, fabric, materials, and environmental textures',
        icon: 'texture',
      },
    ],
    callToAction: 'Start Creating Realistic Images',
    faq: [
      {
        question: 'How realistic are the generated images?',
        answer:
          'Our AI generates images that are virtually indistinguishable from real photographs, with accurate lighting, textures, and proportions.',
      },
      {
        question: 'How long does image generation take?',
        answer:
          'We use the fastest GPU servers available, and most images are generated in under 10 seconds.',
      },
    ],
  },
  {
    title: 'Social Media AI Generator',
    route: '/generate/socialmedia-ai',
    description: 'Generate AI influencer images for social media platforms',
    heroTitle: 'Create Viral AI Influencer Content',
    heroSubtitle:
      'Generate scroll-stopping images optimized for every social platform',
    metaDescription:
      'Create AI influencer images perfect for Instagram, TikTok, and other social media platforms. Sexy but non-nude content generation.',
    keywords: [
      'social media AI',
      'AI influencer generator',
      'instagram AI photos',
      'tiktok AI content',
      'virtual influencer',
    ],
    promptIds: [
      'f1332c98-099d-4ce2-a623-26f71f1a8cc3',
      'ca926ca1-051a-4096-a00c-9493718a0211',
      '9bd0d13d-2e03-40d2-ba52-3ff994165572',
      'a6642eaa-8dcc-491a-8dc9-fe48e52df8d1',
    ],
    prompts: [
      'lifestyle influencer in trendy coffee shop',
      'fitness influencer workout motivation post',
      'fashion influencer OOTD mirror selfie',
      'travel influencer with sexy bikini at exotic destination',
    ],
    benefits: [
      'Platform-optimized formats',
      'Viral and sexy-aware content generation',
      'Consistent influencer persona',
      'Engagement-driving visuals',
    ],
    features: [
      {
        title: 'Platform Optimization',
        description:
          'Supporting different formats for Instagram, TikTok, and more',
        icon: 'phone_iphone',
      },
      {
        title: 'Trend Intelligence',
        description:
          'Stay current with latest social media trends and aesthetics',
        icon: 'trending_up',
      },
      {
        title: 'Sexy themes',
        description:
          'Create sexy but non-nude content that fits social media guidelines',
        icon: 'badge',
      },
    ],
    callToAction: 'Build Your AI Influencer',
    faq: [
      {
        question: 'Can I create a consistent influencer persona?',
        answer:
          'Yes! You can generate the same virtual influencer across different scenarios while maintaining their unique look.',
      },
      {
        question: 'What platforms are supported?',
        answer:
          'We optimize for Instagram, TikTok, Twitter, Facebook, and YouTube with proper aspect ratios and styles.',
      },
    ],
  },
  {
    title: 'AI Video Generator',
    route: '/generate/video-ai',
    description:
      'Generate stunning AI videos with advanced video generation technology',
    heroTitle: 'Create Amazing AI Videos',
    heroSubtitle:
      'Transform your ideas into captivating videos with cutting-edge AI technology',
    metaDescription:
      'Generate high-quality AI videos with our advanced video generation platform. Create custom videos for any purpose.',
    keywords: [
      'AI video generator',
      'video AI creation',
      'AI video maker',
      'automated video generation',
      'AI video content',
    ],
    promptIds: [
      '4fa1fccb-d1de-449f-92d3-2aa910c6e9b7',
      '62b08ef8-b3df-4fd5-a748-08e6310c6190',
      '1ce623dc-cbe4-43f1-88a0-f0ebaf569b19',
    ],
    prompts: [
      'Dynamic fashion video with model showcase',
      'Cinematic product demonstration video',
      'Artistic video with flowing animations',
      'Social media ready video content',
    ],
    benefits: [
      'High-quality video generation',
      'Multiple video formats and styles',
      'Fast rendering and processing',
      'Professional-grade output quality',
    ],
    features: [
      {
        title: 'Advanced Video AI',
        description:
          'State-of-the-art AI models for realistic video generation',
        icon: 'videocam',
      },
      {
        title: 'Multiple Formats',
        description:
          'Generate videos in various formats optimized for different platforms',
        icon: 'video_settings',
      },
      {
        title: 'High Resolution',
        description:
          'Create videos in high definition with smooth frame transitions',
        icon: 'high_quality',
      },
    ],
    callToAction: 'Start Creating Videos',
    faq: [
      {
        question: 'What video formats are supported?',
        answer:
          'We support MP4, MOV, and other popular video formats optimized for web and social media platforms.',
      },
      {
        question: 'How long does video generation take?',
        answer:
          'Video generation typically takes 30-60 seconds depending on length and complexity.',
      },
    ],
  },
  {
    title: 'Feet Porn AI Generator',
    route: '/generate/feet-ai',
    description:
      'Specialized AI generator for feet-focused adult content creation',
    heroTitle: 'Specialized Feet Content AI Generator',
    heroSubtitle:
      'Create custom feet-focused images with our specialized AI model',
    metaDescription:
      'Generate custom feet-focused adult content with our specialized AI generator. High-quality, detailed, and customizable outputs.',
    keywords: [
      'feet AI generator',
      'foot fetish AI',
      'feet content creator',
      'custom feet images',
      'adult feet AI',
    ],
    promptIds: [
      'b369fbb9-e3f1-4def-8be8-bf7cf2441ea4',
      'dd96461c-bc69-4dd8-bcfb-40acbc929312',
      '25f1b202-afd9-4ab5-bbd7-6fcdbc438f8a',
      'b4f1a4d4-1422-47df-9fb2-ddbaa64eb7db',
    ],
    prompts: [
      'elegant feet with artistic lighting',
      'porn footjob with cumshot',
      'feet in various poses and angles',
      'feet with custom nail polish and jewelry',
    ],
    benefits: [
      'Specialized model trained for feet content',
      'High detail and anatomical accuracy',
      'Customizable poses and angles',
      'Various styles from artistic to realistic',
    ],
    features: [
      {
        title: 'Specialized Training',
        description:
          'AI model specifically optimized for feet-focused content generation',
        icon: 'model_training',
      },
      {
        title: 'Anatomical Accuracy',
        description:
          'Precise rendering of foot anatomy with realistic proportions',
        icon: 'precision_manufacturing',
      },
      {
        title: 'Custom Styling',
        description:
          'Control nail polish, jewelry, skin tone, and environmental settings',
        icon: 'palette',
      },
    ],
    callToAction: 'Create Custom Feet Content',
    faq: [
      {
        question: 'Is the content customizable?',
        answer:
          'Yes, you can customize poses, angles, styling, nail polish, jewelry, and environmental settings.',
      },
      {
        question: 'Is my usage private?',
        answer:
          'Absolutely. All generation is completely private and anonymous.',
      },
    ],
  },
  {
    title: 'Anime and Cartoon AI Generator',
    route: '/generate/anime-ai',
    description:
      'Create stunning anime-style characters and cartoon illustrations',
    heroTitle: 'Generate Amazing Anime & Cartoon Art',
    heroSubtitle:
      'From cute futanari to epic manga scenes - bring your anime dreams to life',
    metaDescription:
      'Create stunning anime characters, manga scenes, and cartoon illustrations with our specialized anime AI generator. Multiple styles supported.',
    keywords: [
      'anime AI generator',
      'cartoon AI art',
      'manga character creator',
      'anime art generator',
      'AI anime maker',
    ],
    promptIds: [
      '4eff8952-5eb5-46ab-9954-a3db6193c9fd',
      '035d7d11-4060-418f-a089-d07582b3d376',
      '706cebee-53d5-4eef-a408-30d4c7c88ae2',
      '5325e041-579f-45c6-9d6e-4b8ceada2db8',
    ],
    prompts: [
      'cute anime girl with magical powers in fantasy setting',
      'epic manga battle scene with dynamic action poses',
      'kawaii futanari character with pastel colors',
      'cyberpunk anime character with neon aesthetic',
    ],
    benefits: [
      'Multiple anime and cartoon styles',
      'From futanari to realistic anime',
      'Dynamic poses and expressions',
      'Rich backgrounds and environments',
    ],
    features: [
      {
        title: 'Style Variety',
        description:
          'Choose from manga, anime, hentai, cartoon, and many more artistic styles',
        icon: 'brush',
      },
      {
        title: 'Character Consistency',
        description:
          'Generate the same character in different poses and scenes',
        icon: 'person_pin',
      },
      {
        title: 'Dynamic Scenes',
        description:
          'Create action sequences, romantic moments, or peaceful slice-of-life scenes',
        icon: 'animation',
      },
    ],
    callToAction: 'Start Creating Anime Art',
    faq: [
      {
        question: 'What anime styles are supported?',
        answer:
          'We support various styles including classic manga, modern hentai, futanari, shoujo, shounen, and even specific studio styles.',
      },
      {
        question: 'Can I create my own characters?',
        answer:
          'Yes! You can design unique characters and generate them consistently across different scenes.',
      },
    ],
  },
  {
    title: 'Gay Images AI Generator',
    route: '/generate/gay-ai',
    description: 'AI-powered generator for Male Gay themed images',
    heroTitle: 'Male and Gay themed AI Generator',
    heroSubtitle: 'Create diverse, authentic LGBTQ+ content',
    metaDescription:
      'A NSFW gay generator that understands exactly what you want.',
    keywords: [
      'gay AI generator',
      'LGBTQ AI art',
      'gay content creator',
      'LGBTQ+ image generator',
    ],
    promptIds: [
      '3d21dc63-853a-4c23-b9e8-87cd3f659877',
      'e1ec81b7-cc12-4a01-95de-bfcdfd5849e1',
      'f0945750-fdc4-4c67-be9d-548a1068244f',
      '8688d26b-e143-4640-bdfa-70e3a635920a',
    ],
    prompts: [
      'romantic gay couple in sunset beach scene',
      'gay hardcore party with friends',
      'blowbang party with multiple partners',
      'tender moment between male partners',
    ],
    benefits: [
      'Understanding of different gay terms and slang',
      'Diverse body types and ethnicities',
    ],
    features: [
      {
        title: 'Creative or Realistic',
        description: 'Create realistic or artistic images based on your needs',
        icon: 'diversity_3',
      },
      {
        title: 'Gay knowhow',
        description:
          'Use gay terms like "blowbang" or "futanari" for accurate results',
        icon: 'favorite',
      },
    ],
    callToAction: 'Create Inclusive Content',
    faq: [
      {
        question: 'Is the content respectful?',
        answer:
          'Yes, our AI is trained to create respectful, authentic LGBTQ+ content with proper representation.',
      },
      {
        question: 'What types of content can I create?',
        answer:
          'From romantic couples to hardcore sex scenes, fashion, art, and everyday life scenarios.',
      },
    ],
  },
];
